import Vue from 'vue';
export default Vue.extend({
    name: 'GlobalCommbookLocations',
    props: {
        locations: { type: Array, default: function () { return []; } },
        locationId: { type: String, default: '' },
        classId: { type: String, default: '' },
        collapsed: Boolean,
        loading: Boolean,
        error: { type: String, default: '' },
        starred: Boolean,
        canCreate: Boolean,
        starredUnreadCount: { type: Number, default: 0 }
    },
    data: function () {
        return { expanded: {} };
    },
    watch: {
        locationId: {
            immediate: true,
            handler: function (id) {
                if (id)
                    this.$set(this.expanded, id, true);
            }
        }
    },
    methods: {
        count: function (value) {
            return Number(value || 0).toLocaleString('en-US');
        },
        toggleLocation: function (id) {
            this.$set(this.expanded, id, !this.expanded[id]);
        }
    }
});
